import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, ProtectedRoute } from "@/context/AuthContext";
import { FilterProvider } from "@/context/FilterContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Imports from "@/pages/Imports";
import Rapprochement from "@/pages/Rapprochement";
import Reservations from "@/pages/Reservations";
import Exports from "@/pages/Exports";
import Parametres from "@/pages/Parametres";
import Comparaison from "@/pages/Comparaison";
import Bilan from "@/pages/Bilan";
import Plateformes from "@/pages/Plateformes";
import Recherche from "@/pages/Recherche";
import Commentaires from "@/pages/Commentaires";
import DeclarationTaxes from "@/pages/DeclarationTaxes";
import ConciliationBancaire from "@/pages/ConciliationBancaire";
import EnvoiComptable from "@/pages/EnvoiComptable";
import Fichiers from "@/pages/Fichiers";
import Calendrier from "@/pages/Calendrier";
import Appartements from "@/pages/Appartements";
import ReaffecterOperations from "@/pages/ReaffecterOperations";
import CalculReservation from "@/pages/CalculReservation";
import Demandes from "@/pages/Demandes";
import Bienvenue from "@/pages/Bienvenue";
import Configuration from "@/pages/Configuration";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/bienvenue" element={<Bienvenue />} />
            <Route path="/configuration" element={<ProtectedRoute><FilterProvider><Configuration /></FilterProvider></ProtectedRoute>} />
            <Route
              element={
                <ProtectedRoute>
                  <FilterProvider>
                    <Layout />
                  </FilterProvider>
                </ProtectedRoute>
              }
            >
              <Route path="/" element={<Dashboard />} />
              <Route path="/imports" element={<Imports />} />
              <Route path="/rapprochement" element={<Rapprochement />} />
              <Route path="/reservations" element={<Reservations />} />
              <Route path="/comparaison" element={<Comparaison />} />
              <Route path="/bilan" element={<Bilan />} />
              <Route path="/exports" element={<Exports />} />
              <Route path="/parametres" element={<Parametres />} />
              <Route path="/plateformes" element={<Plateformes />} />
              <Route path="/recherche" element={<Recherche />} />
              <Route path="/commentaires" element={<Commentaires />} />
              <Route path="/declaration-taxes" element={<DeclarationTaxes />} />
              <Route path="/conciliation-bancaire" element={<ConciliationBancaire />} />
              <Route path="/envoi-comptable" element={<EnvoiComptable />} />
              <Route path="/fichiers" element={<Fichiers />} />
              <Route path="/calendrier" element={<Calendrier />} />
              <Route path="/appartements" element={<Appartements />} />
              <Route path="/reaffecter" element={<ReaffecterOperations />} />
              <Route path="/calcul-reservation" element={<CalculReservation />} />
              <Route path="/demandes" element={<Demandes />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
